module.exports = __webpack_public_path__ + "static/media/Quarter_D.86b562d5.png";